export enum WorkingTimeEnum {
  FullTime = 1,
}
